module.exports = __webpack_public_path__ + "img/step-4.7e81446a.jpg";